import * as React from "react";
const Marker = (props) => {
    return React.createElement("div", { className: "marker", onClick: () => {
            let { lat, lng } = props;
            props.MarkerClick({ lat, lng });
        } },
        React.createElement("img", { role: "presentation", src: props.selected ?
                "/img/map-pin-purple.png" :
                "/img/map-pin-blue.png" }),
        React.createElement("span", null, props.markerText + 1));
};
export default Marker;
//# sourceMappingURL=marker.js.map